export const ROUTES = {
  DASHBOARD: 'Dashboard',
  LEADS: 'Leads',
  LEAD: 'Lead',
}
